import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0f2a51d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "window_backdrop",
  key: "id1"
}, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow_left" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow_right" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_dots_navigation = _resolveComponent("dots-navigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(['window_container', {window_container_mobile: _ctx.showMobile}])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['image_viewer_container', {gray_rectangle: _ctx.error}])
      }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!_ctx.error)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.file,
                  onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setLoaded && _ctx.setLoaded(...args))),
                  onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setError && _ctx.setError(...args))),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fullSize = !_ctx.fullSize)),
                  class: _normalizeClass([{_full_size : _ctx.fullSize}, 'image_viewer_image', {_display_none : !_ctx.visible}, {_hidden : !_ctx.loaded}, {_visible : _ctx.loaded}])
                }, null, 42, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (!_ctx.loaded && _ctx.visible)
          ? (_openBlock(), _createBlock(_component_loader, {
              key: 0,
              class: "_loader"
            }))
          : _createCommentVNode("", true)
      ], 2),
      _hoisted_3,
      (_ctx.numberOfImages > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "_left",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('imageViewerPrev')))
          }, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.numberOfImages > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "_right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('imageViewerNext')))
          }, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        src: "/images/icon_plus.svg",
        class: "image_control",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('imageViewerClose')))
      }),
      (_ctx.numberOfImages > 1)
        ? (_openBlock(), _createBlock(_component_dots_navigation, {
            key: 2,
            "number-of-items": _ctx.numberOfImages,
            "active-index": _ctx.activeIndex,
            class: "dots_navigation"
          }, null, 8, ["number-of-items", "active-index"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}